module.exports = __webpack_public_path__ + "img/arrows.5fd2ed42.png";